module.exports = __webpack_public_path__ + "static/media/HealingRelationshipsMother.ad58eee6.jpg";